import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommentsService, ReportComment } from '../../service/comments.service';
import { takeWhile } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { YesNoDialogComponent } from '@app/shared';
import { TableLazyLoadEvent } from 'primeng/table';
import { AuthService, ROLES } from '@app/core/auth';

@Component({
  selector: 'afoone-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.css'],
})
export class CommentListComponent implements OnDestroy, OnInit {
  public records: ReportComment[] = [];
  public selectedRecords: ReportComment[];
  private _lastPagination: TableLazyLoadEvent;

  private destroyed: boolean;

  public totalRecords: number = 0;

  constructor(
    private service: CommentsService,
    private dialogService: DialogService,
    private authService: AuthService
  ) {}

  public ngOnInit(): void {
    const _initialPagination: TableLazyLoadEvent = {
      first: 0,
      rows: 20,
      sortField: 'createdAt',
      sortOrder: -1,
    };
    this.loadRecords(_initialPagination);
  }

  canDelete(): boolean {
    // Only admins can delete comments
    return this.authService.isRole(ROLES.Admin);
  }

  public async loadRecords(pagination?: TableLazyLoadEvent): Promise<void> {
    if (!pagination) {
      pagination = this._lastPagination || {
        first: 0,
        rows: 20,
        sortField: 'createdAt',
        sortOrder: -1,
      };
    } else {
      this._lastPagination = pagination;
    }
    this.selectedRecords = [];

    const _response = await this.service.getComments(pagination);

    this.records = _response.data || [];
    this.totalRecords = _response.count || 0;
  }

  public deleteSelected(): void {
    this.dialogService
      .open(YesNoDialogComponent, {
        height: '300px',
        width: '300px',
        header: 'Eliminar comentarios',
        data: {
          message: '¿Eliminar comentarios seleccionados?',
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        if (result) {
          const deleteRequests = this.selectedRecords.map((record) =>
            this.service.deleteComment(record.id)
          );
          Promise.all(deleteRequests)
            .then(() => {
              this.loadRecords();
            })
            .catch((error) => {
              this.loadRecords();
            });
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
